/*********************** Custom JS for Boost AI Search & Discovery  ************************/

if (boostSDAppConfig?.searchSettings) {
	boostSDAppConfig.searchSettings.highlightSuggestionResult = false;
	boostSDAppConfig.searchSettings.showSuggestionLoading = true;
}

// on page load, get the div with an id of boostSearchContainer and move it after the predictive-search web component
window.addEventListener('load', () => {
  const boostSearchContainer = document.getElementById('boost-sd__instant-search-container');
  const predictiveSearch = document.querySelector('predictive-search');
  if (boostSearchContainer && predictiveSearch) {
    predictiveSearch.insertAdjacentElement('afterend', boostSearchContainer);
  }
  if (window.innerWidth <= 769) {
    var searchInputBoost = document.querySelector('#boost-sd__search-bar-input');
    document.querySelector('a[aria-controls="search-drawer"]').addEventListener('click', function(e){
      document.querySelector('.boost-sd__search-widget-init-input').click();
      searchInputBoost.click();
    });
  }
  
  if (window.innerWidth >= 769) {
    document.querySelector('.search-drawer').addEventListener('click', function(e){
      document.querySelector('#boost-sd__search-widget-init-input-0').click();
    });
  }
});